// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {reduxForm} from 'redux-form'

// Icons

import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'


import './index.css'

class AddForm extends Component {
  renderFormFields () {
    const {fields} = this.props
    if (!fields) {
      return null
    }
    let formFields = fields.map((field) => {
      return ({field})
    })

    return formFields
  }

  render () {
    const {handleSubmit, submitting, invalid, reset, className, fields, onCancel} = this.props
    return (
      <form className={`tr add-form padding-30 container-fluid row ${className}`} onSubmit={handleSubmit}>
        {fields}
        <div className='td form-buttons column-buttons col-1'>
          <div className='button save'>
            <button className='save-button' type='submit' disabled={submitting || invalid}><CheckCircleOutlineOutlinedIcon/>&nbsp; Save</button>
          </div>
          <div className='button cancel'>
            <button className='cancel-button' type='button' onClick={() => {reset(); onCancel()}}><CancelOutlinedIcon/>&nbsp; Cancel</button>
          </div>
        </div>
      </form>
    )
  }
}

function validate (values, props) {
  return props.validate(values)
}

function onSubmit (values, dispatch, props) {
  dispatch(props.onSubmit(values))
}

export default reduxForm({
  form: 'addUserTableFrom',
  onSubmit: onSubmit,
  validate: validate
})(AddForm)
